import { render, staticRenderFns } from "./PopupEditTaxGroup.vue?vue&type=template&id=0a507022&scoped=true&"
import script from "./PopupEditTaxGroup.vue?vue&type=script&lang=js&"
export * from "./PopupEditTaxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a507022",
  null
  
)

export default component.exports